var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"TZ Design Box - Page not found","description":"TZ Design Box"}}),_c('h2',[_vm._v(" "+_vm._s(_vm.$t("page-not-found"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }